// @core/api/endpoints/document/submit_for_approval.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentLifecycleResponse,
  SubmitForApprovalRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Submit for approval
 * Submits any document-aware entity for approval. Changes DocumentAspect.status to PENDING_APPROVAL and creates an ApprovalRequest. Works for standalone documents and domain entities (HROrder, Invoice, etc.).
 */
export async function SubmitForApproval(
  target_type: string,
  target_id: string,
  data: SubmitForApprovalRequest,
  options?: RequestOptions
): Promise<DocumentLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/submit`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<DocumentLifecycleResponse>(requestPath, data, requestOptions);
}
